<div class="wcs-w-full">
    <ng-select [items]="venues" (change)="venueChange.emit(venueId)" bindLabel="name" bindValue="venue_id"
        [(ngModel)]="venueId" [clearable]="false" placeholder="Select Venue"></ng-select>
</div>